import { render, staticRenderFns } from "./AssembleiaConfiguracaoEdit.vue?vue&type=template&id=4b78b540&"
import script from "./AssembleiaConfiguracaoEdit.vue?vue&type=script&lang=js&"
export * from "./AssembleiaConfiguracaoEdit.vue?vue&type=script&lang=js&"
import style0 from "./AssembleiaConfiguracaoEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports